// src/render.js

'use strict';

const typeToTemplate = {
  'html': () => import('partials/html/layout.hbs'),
  'html-css': () => import('partials/html-css/layout.hbs'),
  'html-css-challenge': () => import('partials/html-css-challenge/layout.hbs'),
  'html-css-js-iframe-challenge': () => import('partials/html-css-js-iframe-challenge/layout.hbs'),
  'html-css-js': () => import('partials/html-css-js/layout.hbs'),
  'html-css-js-challenge': () => import('partials/html-css-js-challenge/layout.hbs'),
  'html-less': () => import('partials/html-less/layout.hbs'),
  'html-less-challenge': () => import('partials/html-less-challenge/layout.hbs'),
  'js': () => import('partials/js/layout.hbs'),
  'js-challenge': () => import('partials/js-challenge/layout.hbs'),
  'svg-css': () => import('partials/svg-css/layout.hbs'),
  'svg-css-challenge': () => import('partials/svg-css-challenge/layout.hbs'),
  'php': () => import('partials/php/layout.hbs'),
  'theory': () => import('partials/summary/layout.hbs'),

  'mf/html-css': () => import('partials/mf/html-css/layout.hbs'),
  'mf/html-css-challenge': () => import('partials/mf/html-css-challenge/layout.hbs'),
  'mf/html-less': () => import('partials/mf/html-less/layout.hbs'),
  'mf/html-less-challenge': () => import('partials/mf/html-less-challenge/layout.hbs'),
  'mf/html-css-js': () => import('partials/mf/html-css-js/layout.hbs'),
  'mf/html-css-js-iframe-challenge': () => import('partials/mf/html-css-js-iframe-challenge/layout.hbs'),
  'mf/svg-css': () => import('partials/mf/svg-css/layout.hbs'),
  'mf/svg-css-challenge': () => import('partials/mf/svg-css-challenge/layout.hbs'),
};

const template = (taskType) => {
  const fn = typeToTemplate[taskType];

  if (typeof fn === 'function') {
    return fn;
  }

  return false;
};

const renderTemplate = async (taskType, data) => {
  const getTemplateModule = typeToTemplate[taskType];
  const render = (await getTemplateModule()).default;

  const markup = render(data);
  return markup;
};

module.exports = {
  template,
  renderTemplate
};
